import { Carousel } from "primereact/carousel";
import { CarouselProps } from "../../Domain/Model/Carousel";
import { TopSellingProducts } from "../../Domain/Model/Metric";

export const CarouselDash: React.FC<CarouselProps> = ({ data }) => {
     if (!data || data.length === 0) {
    return <div>No hay imágenes para mostrar</div>;
  }

  const productTemplate = (product: TopSellingProducts) => {
        return (
            <div className="text-center d-flex item-content-carousel">
                <div className="">
                    <img src={`${product.productImageUrl}`} alt={product.productName} className="" />
                </div>
                <div>
                    <p className="m-0">{product.productName}</p>
                </div>
            </div>
        );
    };


    return (
       
            <Carousel value={data} numVisible={1} numScroll={1} orientation="vertical" verticalViewPortHeight="50px"
            itemTemplate={productTemplate} showIndicators={false}  showNavigators={false} autoplayInterval={3000}/>
       
    )

}